import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

export function getStudentsGlobal(): Promise<ApiResponse> {
  return Axios.get(`v1/students/statistics/global`);
}
